// Wrappers around native DOM operations to simplify testing

export const getLocation = () => window.location;
